import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { trackEvent } from '~/api/analytics';
import { Box, CustomSpinner, DataGrid, Pagination } from '~/commonComponents';
import { DashboardJobsType, IDashboardJob } from '~/domain/DashboardJobs';
import { useUserSelector } from '~/hooks';
import { Colors } from '~/themes/colors';
import { FilterStatusEnum } from '~/utils/Enum';
import { useJobList } from '../../hooks';
import { DataGridCommonColumn } from '../DataGrid.column';
import { EmptyMessage } from '../EmptyMessage';

export const OpenTab = () => {
  const currentUser = useUserSelector();
  const navigate = useNavigate();

  const { data, isInitialLoading, isLoading, methods, pagination } = useJobList({
    jobType: DashboardJobsType.OPEN,
  });

  const handleRowClick = useCallback(
    (item: IDashboardJob) => {
      trackEvent('Shifts - Open Shifts Tab - Shift Tile Clicked', {
        shiftId: item?.id,
        shiftSpecialty: item?.specialty,
        procedures: item?.procedures,
        breakTime: item?.lunchBreakTime,
        autoConfirm: item?.autoFill,
        softwares: currentUser?.office_info?.softwares,
        assistedHygiene: item?.isAssistedHygiene,
        tpp: item?.amount,
      });

      navigate(`/dashboard/job/${item.id}`);
    },
    [currentUser?.office_info?.softwares, navigate],
  );

  if (isInitialLoading) {
    return (
      <Box marginTop={32}>
        <CustomSpinner isLoading size={24} />
      </Box>
    );
  }

  return (
    <DataGrid
      EmptyComponent={<EmptyMessage type={FilterStatusEnum.OPEN} />}
      PaginationComponent={
        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={methods.setCurrentPage}
          maxButtons={5}
        />
      }
      columns={[
        DataGridCommonColumn.Office,
        {
          ...DataGridCommonColumn.Type,
          width: '180px',
        },
        DataGridCommonColumn.Details,
        DataGridCommonColumn.Profession,
        DataGridCommonColumn.Rate,
        DataGridCommonColumn.Invite,
        DataGridCommonColumn.Action,
      ]}
      data={data}
      isLoading={isLoading}
      getRowStyle={(item) => ({
        backgroundColor: item.dashboardJobApi.isOnsiteInterview
          ? Colors.jobs_interview_background
          : Colors.jobs_shift_background,
      })}
      keyExtractor={(item) => item.id}
      onRowClick={handleRowClick}
    />
  );
};
